import React from "react";
import { Button } from "@progress/kendo-react-buttons";

interface ResetSelectionButtonProps {
  onReset: () => void;
  hasSelection: boolean;
  disabled?: boolean;
}

export const ResetSelectionButton: React.FC<ResetSelectionButtonProps> = ({ onReset, hasSelection, disabled = false }) => (
  <Button type="button" disabled={disabled || !hasSelection} onClick={onReset}>
    Reset selection
  </Button>
);
